export default __webpack_public_path__ + "static/media/logo.52b7ab1d.svg";